import { render } from "./PasswordChange.vue?vue&type=template&id=1e5dbff6"
import script from "./PasswordChange.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordChange.vue?vue&type=script&setup=true&lang=js"

import "./PasswordChange.vue?vue&type=style&index=0&id=1e5dbff6&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/setting/PasswordChange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e5dbff6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e5dbff6', __exports__)) {
    console.log('reload')
    api.reload('1e5dbff6', __exports__)
  }
  
  module.hot.accept("./PasswordChange.vue?vue&type=template&id=1e5dbff6", () => {
    console.log('re-render')
    api.rerender('1e5dbff6', render)
  })

}


export default __exports__